<template>
  <li
    class="gallery-item"
    :class="{ 'active': isChecked}"
    @click="handleChecked()"
  >
    <span class="check-container">
      <input
        type="checkbox"
        v-model="isChecked"
      >
      <span />
    </span>
    <div
      class="close-container"
    >
      <img :src="`${$root.cdnUrl}assets/icon-close-gray.svg`">
    </div>
    <div
      class="image-item"
    >
      <div
        class="image-container"
        :class="{'loaded': isLoad}"
      >
        <img
          :src="getThumbnailImageUrl"
        >
      </div>
      <div class="image-information">
        <h6 class="image-name">
          {{ file.name }}
        </h6>
        <div class="image-attributes">
          <span>{{ file.createdAt | dateTime('DD.MM.YYYY') }}</span>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'GalleryItem',
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isLoad: false,
      isChecked: false,
    };
  },
  computed: {
    getThumbnailImageUrl () {
      const thumbnailUrl = this.file.url.split('?')[0];
      return `${thumbnailUrl}?x-oss-process=image/resize,w_500,limit_0`;
    },
  },
  methods: {
    handleChecked () {
      const isChecked = !this.file.isChecked;
      this.$set(this.file, 'isChecked', isChecked);
      this.isChecked = isChecked;
      this.$emit('onChecked', this.file);
    },
  },
  created () {
    const image = new Image();
    image.src = this.getThumbnailImageUrl;
    image.onload = () => {
      this.isLoad = true;
    };
    image.onerror = () => {
      this.isLoad = true;
    };
  },
  watch: {
    file () {
      this.isChecked = this.file.isChecked;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-item {
  list-style: none;
  max-width: 50%;
  min-width: 50%;
  padding: 15px;
  position: relative;

  .image-item {
    border-radius: 4px;
    border: solid 1px #dce1e8;
    overflow: hidden;
    width: 100%;
    height: 200px;
    position: relative;

    .image-container {
      opacity: 0;
      transition: all .4s ease;
      height: 100%;

      &.loaded {
        opacity: 1;
      }

      img {
        width: 100%;
        cursor: pointer;
        transition: all .4s ease;
        transform: scale(1);
      }

      &::v-deep .lds-ring {
        width: 100px;
        height: 100px;
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);

        & > div {
          width: 100px;
          height: 100px;
        }
      }
    }

    &:not(.rejected):hover {
      .image-container {
        img {
          transform: scale(1.1);
        }
      }
    }

    .image-information {
      background-color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 12px 5px;
      box-shadow: 0px 20px 15px 15px #000;

      .image-name {
        margin: 0;
        padding: 0;
        font-size: 14px;
        display: block;
        text-align: center;
        color: #273142;
        margin-bottom: 3px;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .image-attributes {
        display: flex;
        font-size: 12px;
        color: #afbbca;

        span {
          flex: 1;
          text-align: left;
        }
      }
    }

    .image-reject-reason {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      opacity: 0;
      transform: translateY(100%);
      color: #ffffff;
      background-color: rgba(39, 49, 66, 0.9);
      transition: all .4s ease;
      padding: 15px;
      font-size: 12px;
      text-align: center;
      a {
        color: #ffffff;
        text-decoration: underline;
      }
    }
  }

  .check-container,
  .close-container{
    position: absolute;
    z-index: 1;
    top: 20px;
    img {
      width: 12px;
    }
  }
  .check-container{
    left: 20px;
    input {
      visibility: hidden;
      position: absolute;
      z-index: -1;
    }
    span {
      position: absolute;
      top: 0;
      left: 0;
      &:before{
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        border: 1px solid rgb(242, 122, 26);
        border-radius: 5px;
      }
      &:after {
        position: absolute;
        top: 4px;
        left: 3px;
        content: '';
        display: block;
        border-color: #ffffff;
        border-style: solid;
        border-width: 0 0 2px 2px;
        transform: rotate(-45deg);
        width: 10px;
        height: 5px;
        display: none;
      }
    }
    input:checked + span {
      &:before{
        background-color: rgb(242, 122, 26);
      }
      &:after {
        display: block;
      }
    }
  }
  .close-container{
    display: none;
    right: 20px;
    color: #ffffff;
    cursor: pointer;
  }

  &.active{
    .image-item{
      border: solid 1px #f27a1a;
      &:after{
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        background-color: rgba(242, 122, 26, 0.2);
      }
    }
    .close-container{
      display: block;
    }
  }

}
</style>
